<template>
  <NuxtLoadingIndicator color="#297FFF" />
  <NuxtLayout>
    <LazyModalsCTA hydrate-on-idle />
    <LazyModalsImagePreview hydrate-on-idle />
    <NuxtPage />
  </NuxtLayout>
</template>